import { render, staticRenderFns } from "./AdminButton.vue?vue&type=template&id=89a07042&scoped=true&"
import script from "./AdminButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AdminButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AdminButton.vue?vue&type=style&index=0&id=89a07042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a07042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a07042')) {
      api.createRecord('89a07042', component.options)
    } else {
      api.reload('89a07042', component.options)
    }
    module.hot.accept("./AdminButton.vue?vue&type=template&id=89a07042&scoped=true&", function () {
      api.rerender('89a07042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AdminButton/AdminButton.vue"
export default component.exports